import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';

const barDefault = {
  xAxisProps: {
    dataKey: 'name',
    textAnchor: 'end',
    verticalAnchor: 'end',
    scaleToFit: false,
    interval: 0,
    fontSize: '10px',
    // scale: 'auto',
  },
  yAxisProps: {
    fontSize: '10px',
  },
};

// const data = [
//   {
//     name: 'Jan',
//     2019: 4000,
//     2020: 2400,
//   },
//   {
//     name: 'Feb',
//     2019: 3000,
//     2020: 1398,
//   },
//   {
//     name: 'Mar',
//     2019: 2000,
//     2020: 9800,
//   },
//   {
//     name: 'Apr',
//     2019: 2780,
//     2020: 3908,
//   },
//   {
//     name: 'May',
//     2019: 1890,
//     2020: 4800,
//   },
//   {
//     name: 'Jun',
//     2019: 2390,
//     2020: 3800,
//   },
//   {
//     name: 'Jul',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Aug',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Sep',
//     2019: 3490,
//     2020: 2000,
//   },
//   {
//     name: 'Oct',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Nov',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Dec',
//     2019: 3490,
//     2020: 4300,
//   },
// ];

function BtaxChartComponent({
  chartData,
}) {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#7f9bdb" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#7790CB" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#b0ffec" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8EEED7" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid height={1} y={0} />
        <XAxis {...barDefault.xAxisProps} dataKey="name" />
        <YAxis axisLine={false} tick={false} />
        <Tooltip />
        {/* TAX PAYMENT */}
        <Area
          type="monotone"
          dataKey="TAX PAYMENT"
          stackId="1"
          stroke="#A3B3F9"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#colorUv)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

BtaxChartComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default BtaxChartComponent;
